import { combineReducers, configureStore } from '@reduxjs/toolkit'
import searchSlice from '../reducers/searchSlice'
import userSlice from '../reducers/userSlice'
import resizeSlice from '../reducers/resizeSlice'
import instructorSlice from '../reducers/instructorSlice'
import chatSlice from '../reducers/chatSlice'
import dashboardSlice from '../reducers/dashboardSlice'

// Define the initial static reducers
const staticReducers = {
	search: searchSlice,
	user: userSlice,
	resize: resizeSlice,
	instructor: instructorSlice,
	chat: chatSlice,
	dashboard: dashboardSlice
}

const combinedReducers = combineReducers(staticReducers)

const store = configureStore({
	reducer: combinedReducers
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
